import { type Draft, PayloadAction } from '@reduxjs/toolkit';
import type { CartsState } from '../CartsState';
import { CustomOrderType } from '../CustomOrderType';
import removeFirstMatchingItemFromArray from '../../removeFirstMatchingItemFromArray';

export interface RemoveAllDiscountCodesFromCartsRequestedPayload {
  readonly requestedActionId: number;
}

export interface RemoveAllDiscountCodesFromCartsSucceededPayload {
  readonly requestedActionId: number;
  readonly customOrderTypes: Array<CustomOrderType>;
}

export interface RemoveAllDiscountCodesFromCartsFailedPayload {
  readonly requestedActionId: number;
  readonly customOrderTypes: Array<CustomOrderType>;
}

export const removeAllDiscountCodesFromCartsRequestedReducer = (
  cartState: Draft<CartsState>,
  action: PayloadAction<RemoveAllDiscountCodesFromCartsRequestedPayload>
): void => {
  const {
    pageActions: {
      removeAllDiscountCodesFromCarts: { pending }
    }
  } = cartState;
  const {
    payload: { requestedActionId }
  } = action;

  pending.push(requestedActionId);
};

export const removeAllDiscountCodesFromCartsSucceededReducer = (
  state: Draft<CartsState>,
  {
    payload: { requestedActionId, customOrderTypes }
  }: PayloadAction<RemoveAllDiscountCodesFromCartsSucceededPayload>
): void => {
  const { pending, succeeded } = state.pageActions.removeAllDiscountCodesFromCarts;

  succeeded.push({
    errorsOn: [],
    removedFrom: customOrderTypes,
    requestedActionId
  });
  removeFirstMatchingItemFromArray(pending, requestedActionId);
};

export const removeAllDiscountCodesFromCartsFailedReducer = (
  state: Draft<CartsState>,
  {
    payload: { requestedActionId, customOrderTypes }
  }: PayloadAction<RemoveAllDiscountCodesFromCartsFailedPayload>
): void => {
  const { pending, failed } = state.pageActions.removeAllDiscountCodesFromCarts;

  failed.push({
    errorsOn: customOrderTypes,
    removedFrom: [],
    requestedActionId
  });
  removeFirstMatchingItemFromArray(pending, requestedActionId);
};
